<div [formGroup]="form" [ngClass]="{ 'wrap-options': question?.forceOptionWrapping }" class="radio-options-container">
  <label *ngFor="let option of question.options" class="radio">
    <input
      [attr.data-qa-id]="question.label + ' ' + option.label"
      [formControlName]="question.id"
      [value]="option.value"
      type="radio"
    />
    {{ option.label }}
    <p class="description" *ngIf="option.description">{{ option.description }}</p>
  </label>
</div>
